export default __webpack_public_path__ + "static/media/download.447aaf17.svg";